module.exports = __webpack_public_path__ + "static/media/noti-bg2.d19a5fb0.jpg";